import { Button } from '../../../shared/components/ui/button';

type ProviderResultsPaginationProps = {
  page: number;
  totalPages: number;
  onPageChange: (page: number) => void;
};

export const ProviderResultsPagination = ({
  page,
  totalPages,
  onPageChange,
}: ProviderResultsPaginationProps) => {
  if (totalPages <= 1) {
    return null;
  }

  return (
    <div className="mt-8 flex items-center justify-center gap-2">
      <Button variant="outline" onClick={() => onPageChange(page - 1)} disabled={page === 1}>
        Previous
      </Button>

      <div className="flex items-center gap-2">
        {Array.from({ length: totalPages }, (_, i) => i + 1).map((candidatePage) => {
          const shouldShow =
            candidatePage === 1 ||
            candidatePage === totalPages ||
            Math.abs(candidatePage - page) <= 1;

          if (!shouldShow) {
            if (candidatePage === 2 || candidatePage === totalPages - 1) {
              return (
                <span key={candidatePage} className="px-2 text-gray-400">
                  ...
                </span>
              );
            }
            return null;
          }

          return (
            <Button
              key={candidatePage}
              variant={candidatePage === page ? 'default' : 'outline'}
              onClick={() => onPageChange(candidatePage)}
              className={candidatePage === page ? 'bg-[#026857] hover:bg-[#025247]' : ''}
            >
              {candidatePage}
            </Button>
          );
        })}
      </div>

      <Button
        variant="outline"
        onClick={() => onPageChange(page + 1)}
        disabled={page === totalPages}
      >
        Next
      </Button>
    </div>
  );
};
